///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { GtthSharedLibsModule } from './shared-libs.module';
import { GtthSharedCommonModule } from './shared-common.module';
import { GtthValidationCustomModule } from './directives/validation-custom/validation-custom.module';
import { SharedSystemInfoStoreModule } from './store/systemInfo/system-info-store.module';
import { AccordionStoreModule } from './store/customerAccordionStore/accordion-store.module';
import { SharedEulaStoreModule } from './store/eula/eula-store.module';
import { SuiTranslatePipe } from '@siklu/sui-lib';

@NgModule({
    imports: [
        GtthSharedLibsModule,
        GtthSharedCommonModule,
        GtthValidationCustomModule,
        SharedSystemInfoStoreModule,
        AccordionStoreModule,
        SharedEulaStoreModule,
        SuiTranslatePipe
    ],
    providers: [DatePipe],
    exports: [GtthSharedCommonModule, GtthValidationCustomModule, DatePipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GtthSharedModule {}
